<template>
    <div>
        <div class="ftj mt35">
            <b class="bl_red tuijian" style="">热门推荐:</b>
            <span v-for="(cate,index) in shophot.cate" :key="index">
                <router-link :to="{path:'/shop/shopsearch', query:{cate_id:cate.id}}" target="_blank" class="sd_aa">
                    {{cate.title}}
                </router-link>
            </span>
        </div>
        <div class="b_li">
            <div v-for="(hot,index) in shophot.hot_product" :key="index" @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)" class="dn_a">
                <router-link :to="{path:'/detail', query:{id:hot.id}}" target="_blank">
                    <img :src="hot.piclink" width="270" height="270" class="sbm">
                    <div class="h250">
                        <p class="gna pt10">{{hot.title}}</p>
                        <p class="pt_g">
                            <em class="p_tag">{{hot.sub_title}}</em>
                        </p>
                        <p class="gp_d mt5">
                            <i class="rmb left">¥</i>
                            <b class="xj left mr5">{{hot.price}}</b>
                            <em class="cs_o">已售{{hot.sale}}件</em>
                        </p>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //数据
            shophot:[],
            type: 1,
        }
    },
    mounted() {
        this.getSearchShopHot(this.$route.query.cate_id);
    },
    methods:{
        //获取所有子分类热销产品
        getSearchShopHot(cate_id) {
            var that = this;
            var params = {};
            params.cate_id = cate_id || "";
            that.$api.getShop.getSearchShopHot(params).then(res => {
                if (res.code == 200) {
                    this.shophot = res.result;
                }
            });
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="dn_a hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="dn_a";
        },
    }
}
</script>

<style scoped>
.tuijian{
float:left;display: inline;float: left;margin: 6px 0;padding: 0 15px;white-space: nowrap;line-height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/shop/shopsearch/shophot.vue